import type { RootState } from '@/store';

import type { TrialStatus } from '../types';

export const selectTrials = (state: RootState) => state.trials.trials;
export const selectTrialsLoading = (state: RootState) => state.trials.loading;
export const selectTrialsSaving = (state: RootState) => state.trials.saving;
export const selectTrialsError = (state: RootState) => state.trials.error;
export const selectTrialsSummary = (state: RootState) => state.trials.summary;
export const selectTrialsFilters = (state: RootState) => state.trials.filters;

export const selectTrialById = (id: string) => (state: RootState) =>
  state.trials.trials.find((trial) => trial.id === id) ?? null;

export const selectTrialsByTenantId = (tenantId: string) => (state: RootState) =>
  state.trials.trials.filter((trial) => trial.tenantId === tenantId);

export const selectActiveTrialByTenantId = (tenantId: string) => (state: RootState) =>
  state.trials.trials.find((trial) => trial.tenantId === tenantId && trial.status === 'ATIVO') ??
  null;

export const selectTrialsByStatus = (status: TrialStatus) => (state: RootState) =>
  state.trials.trials.filter((trial) => trial.status === status);
